import classNames from "classnames";
import { useCallback } from "react";

const Stepper = ({ sections, currentSectionIndex, onClick }) => {
  const handleClick = useCallback(
    (e) => {
      if (onClick) {
        const index = e.currentTarget.id;
        console.log(index, typeof index);
        onClick(Number(index));
      }
    },
    [onClick]
  );

  return (
    sections?.length > 0 && (
      <div className="stepper">
        {sections?.map((_section, i) => (
          <span
            className={classNames(
              "stepper__step-wrapper",
              i <= currentSectionIndex && "stepper__step-wrapper--active"
            )}
            key={i}
          >
            {onClick ? (
              <button
                className="stepper__step"
                disabled={i >= currentSectionIndex}
                id={i}
                onClick={handleClick}
              >
                {i + 1}
              </button>
            ) : (
              <span className="stepper__step">{i + 1}</span>
            )}
            {i < sections?.length - 1 && <span className="stepper__spacer" />}
          </span>
        ))}
      </div>
    )
  );
};

export default Stepper;
